export default __webpack_public_path__ + "static/media/back-icon.c90583d0.svg";